import { render, staticRenderFns } from "./GanttElastic.vue?vue&type=template&id=6fcbe72a"
import script from "./GanttElastic.vue?vue&type=script&lang=js"
export * from "./GanttElastic.vue?vue&type=script&lang=js"
import style0 from "./GanttElastic.vue?vue&type=style&index=0&id=6fcbe72a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports